/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2024 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import React from 'react';

import ServiceNowContainer from './ServiceNowContainer';
import GetPiTokenService from './service/GetPiTokenService';
import GetPiTokenModel from './models/GetPiTokenModel';
import AiAdminRedirect from '../../common/components/Redirect/AiAdminRedirect';

export default {
  path: ['/servicenow', '/configure', '/configure/aistudytest', '/configure/*'],
  exact: false,
  services: [new GetPiTokenService()],
  stores: [
    {
      name: 'getPiToken',
      spec: GetPiTokenModel,
      saveLocally: false,
      initialState: {}
    }
  ],

  render: (props) => {
    const { pathname } = window.location;

    // Handle all /configure paths - redirect to /berlin/testbed
    if (pathname === '/configure' || pathname.startsWith('/configure/')) {
      return <AiAdminRedirect redirectPath="/berlin/testbed" />;
    }

    return <ServiceNowContainer {...props} />; // eslint-disable-line react/prop-types
  }
};
